<template>
  <div style="width: 100%">
    <div class="text-center" style="width: 100%">
      <button class="card-tarja-btn" @click="handleClick" :disabled="isDisabled">
        <v-icon>mdi-television</v-icon>
        <span>Tarja</span>
      </button>
    </div>

    <ModalConfirmAction
      :visible="showDialog"
      title="Exibir enquete na tarja"
      message="Tem certeza que deseja exibir a enquete na tarja?"
      confirm-text="Exibir"
      confirm-color="primary"
      :loading="loading"
      @confirm="confirmExibir"
      @cancel="showDialog = false"
    />
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import { apiClient } from "@/services/api";
import ModalConfirmAction from "@/components/Modal/ModalConfirmAction.vue";

export default {
  components: { ModalConfirmAction },
  props: {
    codProducao: Number,
    id_enquete: Number,
    isDisabled: Boolean,
    enqueteItem: Object,
  },
  data() {
    return {
      loading: false,
      showDialog: false,
      exibirModalConfirmacao: null,
    };
  },
  async created() {
    if (this.codProducao) {
      await this.getConfigTarja({ cod_producao: this.codProducao });
      this.exibirModalConfirmacao = this.configTarja.flg_botao_confirmar_exibicao;
    }
  },
  computed: {
    ...mapGetters({
      configTarja: "tarja_enquete/getConfigTarja",
    }),
  },
  methods: {
    ...mapActions({
      assignTarjaParams: "tarja_enquete/assignTarjaParams",
      getConfigTarja: "tarja_enquete/getConfigTarjaEnquete",
      setQRCodeMode: "producoes/setQRCodeMode",
      updateEnqueteQrCodeFlag: "enquetes/updateEnqueteQrCodeFlag",
    }),
    handleClick() {
      if (this.exibirModalConfirmacao) {
        this.showDialog = true;
      } else {
        this.setEnqueteTarja({
          codProducao: this.codProducao,
          idEnquete: this.id_enquete,
          isFullScreen: false,
        });
      }
    },
    confirmExibir() {
      this.setEnqueteTarja({
        codProducao: this.codProducao,
        idEnquete: this.id_enquete,
      });
    },
    async setEnqueteTarja(value) {
      if (!this.configTarja) {
        this.$toast.warning(
          "Nenhuma configuração de tarja definida! Por favor, crie uma."
        );
        return;
      }

      this.loading = true;

      try {
        const { data } = await apiClient.get(`/listarDadosProducao/${this.codProducao}`);
        const isCombinedMode = data?.producao?.settings?.enquete?.qr_code_combined ?? false;

        await this.setQRCodeMode({
          enabled: isCombinedMode,
          combined: isCombinedMode,
          tarjaMode: true
        });

        await this.updateEnqueteQrCodeFlag({
          cod_producao: this.codProducao,
          qr_code: isCombinedMode,
          qr_code_combined: isCombinedMode,
          tarja_mode: true
        });

        await apiClient.patch(
          `atualizarFlgIsFullScreenTarjaEnquete/${this.configTarja.id}/${this.$store.state.producoes.selectedProducao.cod_producao}`,
          {
            flg_is_fullscreen: false,
          }
        );

        this.assignTarjaParams(value);
        localStorage.setItem("tarjaParams", JSON.stringify(value));

        this.$emit("change", { preserveQRCode: isCombinedMode });

        setTimeout(() => {
          this.loading = false;
          this.showDialog = false;
        }, 250);
      } catch (error) {
        console.error('Error setting enquete tarja:', error);
        this.$toast.error('Erro ao configurar enquete na tarja');
        this.loading = false;
      }
    },
  },
  watch: {
    "$store.state.tarja_enquete.configTarjaEnquete": function (newValue) {
      this.exibirModalConfirmacao = newValue.flg_botao_confirmar_exibicao;
    },
    codProducao: async function (value) {
      await this.getConfigTarja({ cod_producao: value.codProducao });
    },
  },
};
</script>

